type Props = {
    problemsComplete: number;
    totalProblems: number;
    color: string;
    displayMethod: "questionCount" | "timer";
}

export default function ProgressBar(props: Props) {

    const percentComplete = Math.round(props.problemsComplete / props.totalProblems * 100);
    const displayText = props.displayMethod === "questionCount" ? `${props.problemsComplete}/${props.totalProblems}` : `${formatTime(props.totalProblems - props.problemsComplete)}`

    return (
        <div className="flex-grow rounded-lg flex flex-row">
            <div style={{ width: `${percentComplete}%` }} className={`${percentComplete === 0 ? "hidden" : ""} ${props.color} rounded-l-lg text-right pr-4 ${percentComplete === 100 ? "rounded-r-lg" : ""} flex flex-col justify-center`}>
                {percentComplete > 20 ? `${displayText}` : undefined }
            </div>
            <div style={{ width: `${100-percentComplete}%` }} className={`${percentComplete === 100 ? "hidden" : ""} bg-slate-200 rounded-r-lg pl-4 ${percentComplete === 0 ? "rounded-l-lg" : ""} flex flex-col justify-center`}>
                {percentComplete <= 20 ? `${displayText}` : undefined }
            </div>
        </div>

    )
}

function formatTime(secondsRemaining: number) {
    const minutesRemaining = Math.floor(secondsRemaining / 60);
    const secLeft = secondsRemaining - (60*minutesRemaining);
    return `${minutesRemaining}:${String(secLeft).padStart(2, '0')}`;
}